import { render, staticRenderFns } from "./SocialBtn.vue?vue&type=template&id=1f178185&scoped=true"
import script from "./SocialBtn.vue?vue&type=script&lang=js"
export * from "./SocialBtn.vue?vue&type=script&lang=js"
import style0 from "./SocialBtn.vue?vue&type=style&index=0&id=1f178185&prod&lang=scss"
import style1 from "./SocialBtn.vue?vue&type=style&index=1&id=1f178185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f178185",
  null
  
)

export default component.exports